import { useTranslation } from 'react-i18next';
import { Link, Navigate, useSearchParams } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';
import { Helmet } from 'react-helmet';

import { AuthContainer } from '@/components';

import { SignUpForm } from './components/SignUpForm/SignUpForm';

const SignUp = (): JSX.Element => {
  const { t } = useTranslation();
  const isAuth = useAppSelector(userSelectors.getAuth);
  const [searchParams] = useSearchParams();

  if (isAuth) {
    return <Navigate to="/" />;
  }

  const signinLink = () => {
    const strSearchParams = searchParams.toString();
    let signinPath = '/signin';
    if (strSearchParams.length > 0) {
      signinPath += `?${strSearchParams}`;
    }

    return signinPath;
  };

  return (
    <>
      <Helmet>
        <title>AMLBot - {t('translation.create_an_account')}</title>
        <meta
          name="description"
          content="Log in to AMLBot to manage cryptocurrency checks and monitor transactions. Secure your digital assets effectively."
        />
      </Helmet>
      <AuthContainer
        title={t('translation.create_an_account')}
        description={
          <>
            {t('translation.already_have_one')}{' '}
            <Link to={signinLink()} className="link">
              {t('translation.sign_in')}
            </Link>
          </>
        }
        fields={<SignUpForm />}
      />
    </>
  );
};

export default SignUp;
